import React, { Component, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { get, putWithHeadersResponse, put, post, postWithHeadersResponse, postWithHeaders } from '../../../server/actions';
import { _addNotification, _addNotificationError } from '../../../server/util';
import SchoolMealProgramView from '../../SchoolAdmin/SchoolMealProgram/schoolMealProgramView';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';

export const eligibilityOptions = [
    { value: '', label: '' },
    { value: 'Free', label: 'Free' },
    { value: 'Reduced', label: 'Reduced' },
    { value: 'Regular', label: 'Regular' }
];

export const statusOptions = [
    { value: '', label: '' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Verified', label: 'Verified' },
    { value: 'No Response', label: 'No Response' }
];

class ApplicationVerificationUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeFlow: {},
            showFinalizeModal: false,
            finalizeData: {},
            showApplicationModal: false,
            selectedApplicationData: null,
            isLoadingApplication: false,
            showUnmarkModal: false,
            selectedUnmarkApp: null,
            adverseActionState: {},
            isSubmittingAction: false,
            activeActionApplicationId: null,
            incomeApplication : {},
            isFinalDecisionLoading: false,
            showAppealModal: false,
            showFinalDecisionModal: false,
            showProgramDropdown: false,
            selectedProgram: '',
            selectedEligibilityCode: '',
            decisionType: '',
            viewLetter: [], 
            showLetterLogModal: false,
            expandedRow: false           
        };
    }
    componentDidMount = () => {
        this.getEligibilityCodes();
         this._notificationSystem = this.refs.notificationSystem; 
    }
    // get the EligibilityCodes
    getEligibilityCodes = () => {
        const _self = this;
         get(`/eligibilityCodes/search/findByIsActive?isActive=true&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({
                    eligibilityCodes: data._embedded.eligibilityCodes, loading: false
                });
            }).catch(
                (error) => {
                    this.setState({
                        eligibilityCodes: [], loading: false
                    });
                    console.log('Eligibility Codes errors:', error)
                }
            )
    }
    //record the application
    recordIncomeApplication = (app) => {
        this.setState({
            isLoadingApplication: true,
            showApplicationModal: true,
            selectedApplicationData: null,
            currentVerificationId: app.verifyId,
        });
        let verificationId = app.verifyId;
        get(`/verification/householdRecord/${verificationId}?access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                this.setState({
                    selectedApplicationData: data,
                    isLoadingApplication: false
                });
                console.log("selectedApplicationDate::::::::", this.state.selectedApplicationData);
            })
            .catch((error) => {
                console.log('Failed to load household application details', error);
                this.setState({ isLoadingApplication: false });
            });
    };
 //save Application
    saveIncomeApplication = (requestBody) => {
        console.log("Received Payload", requestBody);
        const verificationId = this.state.selectedApplicationData.verifyId;
        const headers = {
            "Content-Type": "application/json"
        };
        this.setState({loading: true});
        postWithHeaders( `/verification/addIncome/${verificationId}?access_token=`, JSON.stringify(requestBody),headers
        ).then((response)=>{
            if(response.status===200){
                _addNotification("Income recorded successfully.",  this);
                this.closeApplicationModal();
                if(this.props.refreshApplications){
                    this.props.refreshApplications();
                 }
            }
        })
        .catch(error=>{
            _addNotificationError(error,this);
        });
    }
//ReEnter Income Application
    upDateIncomeApplication = (requestBody) => {
       const verificationId = this.state.selectedApplicationData.verifyId;
       const headers = {
        "Content-Type": "application/json"
        };
       this.setState({loading: true});
        putWithHeadersResponse( `/verification/updateIncome/${verificationId}?access_token=`, JSON.stringify(requestBody), headers
         ) .then((response)=>{
            if(response.status===200){
                _addNotification( "Income updated successfully.", this  );
                this.closeApplicationModal();
                 if(this.props.refreshApplications){
                    this.props.refreshApplications();
                 }
            }
        })
        .catch(error=>{
            _addNotificationError(error,this);
        });
    }

    handleVerificationIncomeSave = (updatedApplication) => {
        if (this.state.verificationMode === "RECORD") {
            this.saveIncomeApplication(updatedApplication);
        } else if (this.state.verificationMode === "REENTER") {
            this.upDateIncomeApplication(updatedApplication);
        }
    }

    // close the application model
    closeApplicationModal = () => {
        this.setState({
            showApplicationModal: false,
            selectedApplicationData: null,
            isLoadingApplication: false
        });
    };

    updateAdverseActionState = (applicationId, key, value) => {
        this.setState(prevState => ({
            adverseActionState: {
                ...prevState.adverseActionState,
                [applicationId]: {
                    ...(prevState.adverseActionState[applicationId] || {}),
                    [key]: value
                }
            }
        }));
    };

    getAdverseActionState = (applicationId) => {
        return this.state.adverseActionState[applicationId] || {
            appealFiled: false,
            finalDecision: false,
            selectedProgram: '',
            selectedEligibilityCode: ''
        };
    };

    getVerificationId = (app) => {
        return app && (app.verifyId || app.verificationId || app.id || (app.verification && app.verification.id)) || null;
    };

   handleAppealToggle = (app, checked) => {
        this.updateAdverseActionState(app.applicationId, 'appealFiled', checked);
        if (checked) {
            this.setState({ showAppealModal: true, selectedRow: app });
        } else {
            this.updateAdverseActionState(app.applicationId, "appealFiled", false);
            this.updateAdverseActionState(app.applicationId, "finalDecision", false);
        }
   };
   
   closeAppealModal = () => {
        this.setState({
            showAppealModal: false,
            selectedRow: null
        });
    };

   cancelAppealModal = () => {
    const { selectedRow } = this.state;
    if (selectedRow) {
        this.updateAdverseActionState( selectedRow.applicationId, 'appealFiled', false );
      }
      this.setState({ showAppealModal: false, selectedRow: null });
    };

    handleFinalDecision = (app, checked) => {
      this.setState({
        showFinalDecisionModal: true,
        selectedRow: app,
        showProgramDropdown: false,
        selectedProgram: ''
     });
    };

    handleDecisionChoice = (type) => {
        if (type === 'YES') {
            this.setState({
            decisionType: 'YES',
            showProgramDropdown: true,
            selectedProgram: '',
            selectedEligibilityCode: ''
            });
        } else {
            this.setState({
            decisionType: 'NO',
            showProgramDropdown: false,
            selectedProgram: '',
            selectedEligibilityCode: ''
            });
        }
    };
    closeFinalDecisionModal = () => {
        this.setState({
            showFinalDecisionModal: false,
            selectedRow: null,
            showProgramDropdown: false,
            decisionType: '',
            selectedProgram: '',
            selectedEligibilityCode: ''
        });
  };

   //adverseAction AppealField
    confirmAppeal = (app) => {
        const applicationId = app && app.applicationId;
        const verificationId = app && (app.verifyId || app.verificationId || app.id);
        if (!applicationId || !verificationId) {
            _addNotificationError('Unable to submit appeal because the application details are incomplete.', this);
            return;
        }
        this.updateAdverseActionState(applicationId, 'appealFiled', true);
        this.updateAdverseActionState(applicationId, 'finalDecision', false);
        if (this.props.showHideLoading) {
            this.props.showHideLoading(true);
        }
        const requestBody = JSON.stringify({
            hasFiledForAppeal: true
        });
        putWithHeadersResponse(`/adverseAction/application/${applicationId}/${verificationId}/appealFiled?access_token=`, requestBody, {
            'Content-Type': 'application/json'
        }).then((response) => {
                if (response.status === 400) {
                    return response.json().then((body) => {
                        const message = body.errorMessage || body.statusMessage || 'An error occurred while filing the appeal.';
                        _addNotificationError(message, this);
                        throw new Error(message);
                    });
                }
                if (!response.ok) {
                    return response.text().then((text) => {
                        throw new Error(text || 'Unable to file the appeal.');
                    });
                }
                return response.json().catch(() => ({}));
            })
            .then((data) => {
                if (data && data.statusMessage) {
                    this.closeAppealModal();
                    _addNotification(data.statusMessage, this);
                } else {
                    this.closeAppealModal();
                    _addNotification('Appeal filed successfully.', this);
                }
            })
            .catch((error) => {
                console.error('Error filing appeal:', error);
                _addNotificationError(error.message || 'Unable to file the appeal.', this);
            })
            .finally(() => {
                if (this.props.showHideLoading) {
                    this.props.showHideLoading(false);
                }
            });
    };

    //AdverseAction FinalDecision
    updateFinalDecision = (app,statusChange) => {
        this.setState({ isFinalDecisionLoading: true });
        const applicationId = app && app.applicationId;
        const verificationId = app && (app.verifyId || app.verificationId || app.id);
        const adverseState = this.getAdverseActionState(applicationId);
        const { selectedRow, selectedProgram, selectedEligibilityCode } = this.state;
            if (!applicationId || !verificationId) {
                _addNotificationError('Unable to submit final decision because the application details are incomplete.', this);
                return;
            }
            if (statusChange && !selectedProgram) {
                alert('Please select a program');
                return;
            }
            if (statusChange && selectedProgram !== 'Regular' && !selectedEligibilityCode) {
                alert('Please select an eligibility code');
                return;
            }
            if (this.props.showHideLoading) {
                this.props.showHideLoading(true);
            }
        const headers = {
            'Content-Type': 'application/json'
        };
        const reqBody = JSON.stringify({
            statusChanged: statusChange,
            selectedStatus: this.state.selectedProgram,
            category: this.state.selectedEligibilityCode || ''
        });
        putWithHeadersResponse(`/adverseAction/application/${applicationId}/${verificationId}/finalDecision?access_token=`, reqBody, headers)
            .then((response) => {
                if (response.status === 400) {
                    return response.json().then((body) => {
                        const message = body.errorMessage || body.statusMessage || 'An error occurred while recording the final decision.';
                        _addNotificationError(message, this);
                        throw new Error(message);
                    });
                }
                if (!response.ok) {
                    return response.text().then((text) => {
                        throw new Error(text || 'Unable to record the final decision.');
                    });
                }
                return response.json().catch(() => ({}));
            })
            .then((data) => {
                this.updateAdverseActionState(applicationId, 'finalDecision', true);
                if (data && data.statusMessage) {
                    this.closeFinalDecisionModal();
                    _addNotification(data.statusMessage, this);
                    if(this.props.refreshApplications){
                    this.props.refreshApplications();
                 }
                } else {
                     this.closeFinalDecisionModal();
                    _addNotification('Final decision recorded successfully.', this);
                }
            })
            .catch((err) => {
                this.setState({isFinalDecisionLoading: false});
                console.error('Error recording final decision:', err);
                _addNotificationError(err.message || 'Unable to record the final decision.', this);
            })
            .finally(() => {
                if (this.props.showHideLoading) {
                    this.props.showHideLoading(false);
                }
            });
     };
//MarkAsResponded
    updateMarkAsResponded = (app) => {
        const verificationId = this.getVerificationId(app);
            this.setState({
                isSubmittingAction: true,
                activeActionApplicationId: app && app.applicationId
            });
        const requestBody = JSON.stringify({ declination: false });
        postWithHeaders(`/verification/markRespond/${verificationId}?access_token=`, requestBody, {
            'Content-Type': 'application/json'
        }).then((response) => {
            console.log('Mark as responded response:', response);
                if (!response || response.status !== 200) {
                    throw new Error('Unable to mark the application as responded1111.');
                }
                _addNotification('Application marked as responded successfully.', this);
                    this.props.refreshApplications();
            })
            .catch((err) => {
                console.error('Error marking as responded:', err);
                _addNotificationError(err.message || 'Unable to mark application as responded222.', this);
                 this.props.refreshApplications();
            })
            .finally(() => {
                this.setState({
                    isSubmittingAction: false,
                    activeActionApplicationId: null
                });
            });
    };

    openUnmarkModal = (app) => {
        this.setState({
            showUnmarkModal: true,
            selectedUnmarkApp: app || null
        });
    };

    closeUnmarkModal = () => {
        this.setState({
            showUnmarkModal: false,
            selectedUnmarkApp: null
        });
    };
//Unmark Application
    confirmUnmark = () => {
        const app = this.state.selectedUnmarkApp;
        const verificationId = this.getVerificationId(app);
        if (!verificationId) {
            _addNotificationError('Unable to un-mark the application because verification details are missing.', this);
            return;
        }
        this.setState({
            isSubmittingAction: true,
            activeActionApplicationId: app && app.applicationId
        });
        post(`/verification/unrespond/${verificationId}?access_token=`)
            .then((response) => {
                if (!response || response.status !== 200) {
                    throw new Error('Unable to un-mark the application.');
                }
                _addNotification('Application un-marked successfully.', this);
                    this.props.refreshApplications();
            })
            .catch((err) => {
                console.error('Error un-marking response:', err);
                _addNotificationError(err.message || 'Unable to un-mark application response.', this);
                 this.props.refreshApplications();
            })
            .finally(() => {
                this.setState({
                    isSubmittingAction: false,
                    activeActionApplicationId: null,
                    showUnmarkModal: false,
                    selectedUnmarkApp: null
                });
            });
    };
 
    rePrintInitialPdf = (app) => {
        const districtId = sessionStorage.getItem("districtId");
        const verificationId = app.verifyId;
        this.setState({ loading: true });
           post(`/verification/reprintInitialLetter/${districtId}/${verificationId}?access_token=`)
             .then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.blob();
           }).then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `InitialVerificationLetter_${verificationId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.setState({ loading: false });
          })
           .catch((error) => {
            this.setState({ loading: false });
            _addNotificationError(  error.userMessage || "Failed to download Initial Verification Letter.", this
            );
            console.log("rePrintInitialPdf error:", error);
         });
     };  
     //View Letter In Log
     viewLetterInLog = (app) => {
        const verificationId = app.verifyId;
        this.setState({ loading: true });
        get(`/verification/communications/${verificationId}?access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({
                    viewLetter: data, loading: false
                });
            }).catch(
                (error) => {
                    this.setState({
                        viewLetter: [], loading: false
                    });
                    console.log('viewLetterInLog:', error)
                }
            )
    }
    //letterLog pdf download
    downloadPdf = ( letter ) => {
        const verificationId = letter.verifyId;
        const logId = letter.logId;
        this.setState({ loading: true });
        get(`/verification/communications/download/${verificationId}/${logId}?access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.blob();
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `LetterLog_${verificationId}_${logId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ loading: false });
                _addNotificationError(error.userMessage || "Failed to download Letter Log PDF.", this);
                console.log("downloadPdf error:", error);
            });
        }
    //complete verification
    completeverification = (app) => {
        const verificationId = app.verifyId;
        this.setState({ loading: true });
        get(`/verification/finalize/preview/${verificationId}?access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({
                    finalizeData: data, loading: false
                });
            }).catch(
                (error) => {
                    this.setState({
                         loading: false
                    });
                    console.log('finalizeData:', error)
                }
            )
    }
     openViewLetterLog = (app) => {
        this.viewLetterInLog(app);
        this.setState({ showLetterLogModal:true });
     };

     closeLetterLogModal = (app) => {
       this.setState({ showLetterLogModal: false });
     };


    openFinalDecisionModal = (app) => {
        this.completeverification(app);
        this.setState({
            showFinalizeModal: true,
        });
    };

    closeFinalizeModal = () => {
        this.setState({ 
               showFinalizeModal: false,
               finalizeData: {} });
       };

    confirmCompleteVerification = (app) => {
         const verificationId = app.verifyId;
         this.setState({ loading: true });

        post(`/verification/finalize/${verificationId}?access_token=`)
            .then((response) => {
                if (!response || response.status !== 200) {
                    throw new Error('Unable to confirm complete verification.');
                }
                this.closeFinalizeModal();
                _addNotification('Application is successfully verified.', this);
                if(this.props.refreshApplications){
                    this.props.refreshApplications();
                 }
            })
            .catch((err) => {
                console.error('Error confirm response:', err);
                _addNotificationError(err.message || 'Unable to confirm the application response.', this);
            })       
    };

    getLetterLogColumns = () => [
      {
        Header: "Type",
        accessor: "communicationType",
        width: 220,
        style: { textAlign: 'center'},
        Cell: row => (
            <span className="label label-primary" style={{
                                                borderRadius: '999px'}}> {row.value}</span>
            )
     },
     {
        Header: "Channel",
        accessor: "channel",
        width: 100,
        style: { textAlign: 'center'},
        Cell: row => (
            <span className="label label-success" style={{
                                                borderRadius: '999px'}}>
                {row.value}
            </span>
        )
     },
     {
        Header: "Sent Date",
        accessor: "sentDate",
        width: 180,
        style: { textAlign: 'center'},
         Cell: ({ value }) =>
         value
            ? moment(value).isValid()
                ? moment(value).format("YYYY/MM/DD")
                : value
            : "-"
     },
     {
        Header: "Recipient",
        accessor: "recipientEmail",
        style: { textAlign: 'center'}
     },
     {
        Header: "Document",
        accessor: "documentAvailable",
        style: { textAlign: 'center'},
        width: 170,
        sortable: false,
        filterable: false,
        Cell: row => (
            row.original.documentAvailable ? (
                <div>
                    <button
                        className="btn btn-xs btn-success" style={{
                                                borderRadius: '999px'}}
                        onClick={() => this.downloadPdf(row.original)}
                    >
                        <i className="fa fa-download" /> Download
                    </button>
                </div>
            ) : (
                <span className="label label-default" style={{
                                                        borderRadius: '999px'}}>
                    No PDF
                </span>
            )
        )
     }
 ];

    renderTimeline = (app) => {
        if (app.entryMethod === "DIRECT_VERIFICATION" || app.entryMethod === "VERIFICATION_LETTER") {
            return ( <div> 
                       <div className = 'col-md-4'>
                         {/* Direct Verification Badge */}
                            <span className="label col-md-12"
                                    style={{backgroundColor: '#e8f2ff',
                                            color: '#2a69c7',
                                            padding: '10px',
                                            fontSize: '14px',
                                            borderRadius: '10px',
                                        }} >
                                        <i className="fa fa-shield"></i>
                                        {' '}
                                        {app.entryMethodLabel}
                            </span>
                       </div>
                   <br />
                <br />
                {/* Locked Message */}
                {/* <div className = 'col-md-10' 
                    style={{
                        background: '#f7f5f1',
                        borderRadius: '8px',
                        padding: '15px',
                        marginLeft: '1%',
                        width: '98%',
                    }} >
                    <i className="fa fa-lock" style={{  marginRight: '8px', color: '#666' }}/>
                    {app.resolvedState}.{app.responseStatus}
                </div>   */}
                <div className = 'col-md-12'>
                {this.renderLetterTimeline(app)}
                </div>
           </div>                 
         );
       }
    }

    renderLetterTimeline = (app) => {
            const timeline = app.timeline || [];
            const statusConfig = (status) => {
                               switch (status) {
                                        case "complete":
                                            return {
                                                icon: "fa-check",
                                                bg: "#5cb85c",
                                                color: "#fff"
                                            };
                                        case "scheduled":
                                            return {
                                                icon: "fa-clock-o",
                                                bg: "#d98b18",
                                                color: "#fff"
                                            };
                                        case "in_progress":
                                            return {
                                                icon: "fa-pencil-square-o",
                                                bg: "#2f80ed",
                                                color: "#fff"
                                            };
                                        case "skipped":
                                            return {
                                                icon: "fa-times",
                                                bg: "#ffffff",
                                                color: "#999",
                                                border: "2px solid #ccc"
                                            };

                                        case "pending":
                                            return {
                                                icon: "fa-envelope-o",
                                                bg: "#ffffff",
                                                color: "#999",
                                                border: "2px solid #ccc"
                                            };
                                        case "paused":
                                            return {
                                                icon: "fa-pause",
                                                bg: "#ffffff",
                                                color: "#999",
                                                border: "2px solid #ccc"
                                            }
                                        default:
                                            return {
                                                icon: "fa-envelope-o",
                                                bg: "#ffffff",
                                                color: "#999",
                                                border: "2px solid #ccc"
                                            };
                                    }
                         };
    return (
          <div style={{ marginTop: 20 }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between"  }} >
                {timeline.map((step, index) => {
                    const config = statusConfig(step.status);
                    return (
                        <React.Fragment key={index}>
                            <div style={{flex: 1, textAlign: "center" }} >   
                                <div style={{
                                        width: 46,
                                        height: 46,
                                        borderRadius: "50%",
                                        background: config.bg,
                                        color: config.color,
                                        border: config.border || "none",
                                        margin: "0 auto",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: 18
                                    }}
                                > <i className={"fa " + config.icon} />
                                </div>
                                <div style={{marginTop: 8, fontWeight: "bold" }} >
                                    {step.stage}
                                </div>
                                {step.date &&
                                    <div style={{ fontSize: 12, color: "#666"}} >
                                        {step.date}
                                    </div>
                                }
                                {step.description &&
                                    <div style={{ fontSize: 12, color: "#999" }} >
                                        {step.description}
                                    </div>
                                }
                                {step.status &&
                                <div >
                                    {step.status}
                                </div>
                                }
                            </div>
                            {index !== timeline.length - 1 &&
                                <div style={{
                                        flex: 0.4,
                                        marginTop: 22,
                                        borderTop: "2px dashed #ddd"
                                    }}   />
                            }
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
   };
  toggleApplicationCard = (applicationId) => {
    this.setState(prevState => ({
        expandedRow:
            prevState.expandedRow === applicationId
                ? null
                : applicationId
     }));
  }
  renderApplicationCard = (app) => {
        if (!app) {
            return null;
        }
        const expanded = this.state.expandedRow === app.applicationId;
        const appActions = app.actions || {};
        const adverseState = this.getAdverseActionState(app.applicationId);
        const adverseAction = app.timeline.find(item => item.stage === "Results");
        return (
            <div>
                <div className="panel"
                     style={{
                        borderRadius: '18px',
                        margin: '15px 0',
                        boxShadow: '0 4px 18px rgba(0, 0, 0, 0.06)',
                        border: '1px solid #e6e6e6',
                        overflow: 'hidden',
                        background: '#fff'
                    }}
                >
                    <div className="panel-heading"
                        style={{
                            background: '#f8f9fb',
                            padding: '18px 20px',
                            borderBottom: '1px solid #eceef3'
                        }}
                    >
                        <div className="row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                             <button className="btn btn-danger btn-sm" style={{  width: "32px",
                                                                                height: "22px",
                                                                                minWidth: "32px",
                                                                                padding: "0",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                borderRadius: "4px"
                                                                             }}
                                    onClick={() => this.toggleApplicationCard(app.applicationId)}
                                > <i className={expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{ fontSize: "10px" }} />
                            </button>
                            <div className="col-md-8">
                                <h4 style={{ margin: '0 0 -16px 0', fontSize: '18px', fontWeight: 700 }}>
                                    Application {app.applicationId}
                                    {adverseAction && adverseAction.status == "complete" ? (
                                                    <span className="label"
                                                        style={{
                                                            borderRadius: '999px',
                                                            color: '#c88428',
                                                            padding: '8px 12px',
                                                            fontSize: '14px',
                                                            marginLeft: '10px'
                                                        }}
                                                    >
                                                        {app.resolvedState}
                                                     </span>) :
                                                     (<span className="label"
                                                        style={{
                                                            borderRadius: '999px',
                                                            color: '#c88428',
                                                            padding: '8px 12px',
                                                            fontSize: '14px',
                                                            marginLeft: '10px'
                                                        }}
                                                    >
                                                         {app.responseStatus}
                                                     </span>)}
                                </h4>
                                <small style={{ color: '#6b7280' }}>
                                    Applied {app.appliedDate} - {app.applicationCategory}
                                </small>
                            </div>
                            <div className="col-md-4 text-right">
                                <span
                                    className="label label-default"
                                    style={{
                                        borderRadius: '999px',
                                        fontSize: '14px',
                                        padding: '6px 10px'
                                    }}
                                >
                                    {app.currentEligibility}
                                </span>
                                <span style={{ margin: '0 8px', color: '#999' }}>→</span>
                                <span
                                    className="label label-primary"
                                    style={{
                                        borderRadius: '999px',
                                        fontSize: '14px',
                                        padding: '6px 10px'
                                    }}
                                >
                                    {app.calculatedEligibility}
                                </span>
            
                            </div>
                        </div>
                    </div>
                </div>
                {expanded && (
                    <Fragment>
                        <div className="panel-body" style={{ padding: '20px 20px 10px' }}>
                            {this.renderTimeline(app)}
                        </div>
                       { app.adverseActionInProgress && (
                                        <div
                                            style={{
                                                margin: '0 20px 20px',
                                                padding: '16px 18px',
                                                background: '#fdf3f3',
                                                border: '1px solid #f3d6d6',
                                                borderRadius: '12px'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                                <div>
                                                    <h4 style={{ margin: '0 0 6px 0', color: '#a94442', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                                        Adverse Action
                                                    </h4>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: '12px', flexWrap: 'wrap', gap: '16px' }}>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={adverseState.appealFiled}
                                                        onChange={(e) => this.handleAppealToggle(app, e.target.checked)}
                                                    />
                                                    Appeal Filed
                                                </label>
                                                    <div style={{color: '#7a4b4b', fontSize: '13px' }}>
                                                {adverseState.appealFiled
                                                    ? 'process paused - The clock is paused until the final decision is recorded.'
                                                    : 'Pause the process and capture the household response before finalizing.'}
                                            </div>
                                        </div>
                                        <div>
                                                <label
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        fontWeight: 600,
                                                        opacity: adverseState.appealFiled ? 1 : 0.65
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={adverseState.finalDecision}
                                                        onChange={(e) => this.handleFinalDecision(app,e.target.checked)}
                                                        disabled={!adverseState.appealFiled}
                                                    />
                                                    Final Decision
                                                </label>
                                            </div>
                                            {!adverseState.finalDecision && (
                                                <div
                                                    style={{
                                                        marginTop: '10px',
                                                        padding: '10px 12px',
                                                        background: '#fff8e1',
                                                        border: '1px solid #f2d9a0',
                                                        borderRadius: '8px',
                                                        color: '#8a6d3b',
                                                        fontSize: '13px'
                                                    }}
                                                >
                                                    If the window passes with no response, appeal, or income, this automatically completes as non-response and downgrades to Paid. Recording income pauses adverse action.
                                                </div>
                                            )}
                                        </div>
                              )  }
                        <div style={{ padding: '0 20px 20px' }}>
                                             <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    flexWrap: 'wrap',
                                                    gap: '10px',
                                                    padding: '14px 16px',
                                                    borderTop: '1px solid #eceef3',
                                                    background: '#fafafa',
                                                    borderRadius: '10px'
                                                 }}
                                             >
                                                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                    {/* {adverseAction && adverseAction.status == "complete" ? (
                                                    <span className="label"
                                                        style={{
                                                            background: '#fcd298',
                                                            borderRadius: '999px',
                                                            color: '#c88428',
                                                            padding: '8px 12px',
                                                            fontSize: '14px',
                                                            marginTop:'10px'
                                                        }}
                                                    >
                                                        {app.resolvedState}
                                                     </span>) :
                                                     (<span className="label"
                                                        style={{
                                                            background: '#fcd298',
                                                            borderRadius: '999px',
                                                            color: '#c88428',
                                                            padding: '8px 12px',
                                                            fontSize: '14px',
                                                            marginTop:'10px'
                                                        }}
                                                    >
                                                         {app.responseStatus}
                                                     </span>)} */}
                                                     {appActions.reprintInitial && (
                                                         <button
                                                             className="btn btn-success btn-sm"
                                                             style={{ borderRadius: '10px' }}
                                                             onClick={() => this.rePrintInitialPdf(app)}
                                                         >
                                                             Reprint Initial
                                                         </button>
                                                     )}
                                                 </div>
                                                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                     <button
                                                         className="btn btn-success btn-sm"
                                                         style={{ borderRadius: '10px' }}
                                                         onClick={() => this.props.openNotesDialog(app)}
                                                     >
                                                         <i className="fa fa-sticky-note"></i>
                                                         &nbsp;Note
                                                     </button>
                                                     {appActions.reEnterIncome && (
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            style={{ borderRadius: '10px' }}
                                                            onClick={() => {
                                                                    this.setState({ verificationMode: "REENTER" }, () => {
                                                                        this.recordIncomeApplication(app);
                                                                    });
                                                                }}
                                                        >
                                                             Re-Enter Income
                                                         </button>
                                                     )}
                                                     {appActions.markAsResponded && (
                                                         <button
                                                             className="btn btn-primary btn-sm"
                                                             style={{ borderRadius: '10px' }}
                                                             onClick={() => this.updateMarkAsResponded(app)}
                                                         >
                                                             {this.state.isSubmittingAction && this.state.activeActionApplicationId === app.applicationId ? 'Processing...' : 'Mark as Responded'}
                                                         </button>
                                                     )}
                                                    {appActions.unmarkResponse && (
                                                         <button
                                                            className="btn btn-primary btn-sm"
                                                            style={{ borderRadius: '10px' }}
                                                            onClick={() => this.openUnmarkModal(app)}
                                                            disabled={this.state.isSubmittingAction && this.state.activeActionApplicationId === app.applicationId}
                                                        >
                                                            Un-mark
                                                        </button>
                                                   )}
                                                    {appActions.recordIncome && (
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        style={{ borderRadius: '10px' }}
                                                        //disabled={!appActions.recordIncome}
                                                        onClick={() => {
                                                                this.setState({ verificationMode: "RECORD" }, () => {
                                                                    this.recordIncomeApplication(app);
                                                                });
                                                            }}
                                                    >
                                                         Record Income
                                                     </button>
                                                   )}
                                                   {appActions.completeVerification && (
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        style={{ borderRadius: '10px' }}
                                                        onClick={() => this.openFinalDecisionModal(app)}
                                                        //disabled={!appActions.completeVerification}
                                                    >
                                                        Complete Verification
                                                    </button>
                                                   )}
                                                    {appActions.viewLetterInLog && (
                                                        <button 
                                                            className="btn btn-success btn-sm" 
                                                            style={{ borderRadius: '10px' }}
                                                            onClick={() => this.openViewLetterLog(app)}>
                                                            View Letter In Log
                                                        </button>
                                                    )}
                                                 </div>
                                             </div>
                                         </div>
                    </Fragment>
                )}
            </div>
        );
    };

     render() {
        const { householdAppsToVerify = [], openNotesDialog, applicationListData, refreshApplications  } = this.props;
        return (
            <Fragment>
                 <NotificationSystem ref="notificationSystem" />
                <div className="row">
                <ReactTable
                    data={applicationListData || []}
                    defaultPageSize={5}
                    pageSizeOptions={[5, 10, 20]}
                    showPagination={true}
                    sortable={false}
                    filterable={false}
                    showPageSizeOptions={true}
                    minRows={0}
                    className="-striped -highlight"
                    columns={[
                        {
                            Header: "",
                            accessor: "applicationId",
                            Cell: row => this.renderApplicationCard(row.original)
                        }
                    ]}
               />
            </div>
            <Modal show={this.state.showAppealModal} onHide={this.closeAppealModal} >
                 <Modal.Header closeButton>
                    <Modal.Title>
                        <h4 className="modal-title modal-title-color">Confirm Appeal Filing</h4>
                    </Modal.Title>
                   </Modal.Header>
                    <Modal.Body >
                         <p style={{ marginTop: '15px' }}>
                           This student will continue to receive their original benefits until a final hearing decision is made.
                         </p>
                     </Modal.Body>
                     <Modal.Footer>
                         <div className='text-right'>
                         <button type="button" className="btn btn-primary btn-sm" onClick={this.cancelAppealModal}>Cancel</button>
                         <button type="button" className="btn btn-success btn-sm" style={{ marginBottom: '17px' }}  onClick={() => this.confirmAppeal(this.state.selectedRow)}>Confirm</button>
                         </div>
                     </Modal.Footer>
                   </Modal>
                   <Modal show={this.state.showFinalDecisionModal} onHide={this.closeFinalDecisionModal}>
                        <Modal.Body >
                                 <p>Has the student's new status changed?</p>
                   
                                 <button type="button" className="btn btn-success btn-sm" onClick={() => this.handleDecisionChoice('YES')}>Yes</button>
                                 <button type="button" className="btn btn-primary btn-sm" onClick={() => this.handleDecisionChoice('NO')}>No</button>
                   
                                 {this.state.showProgramDropdown && (
                                   <div style={{ marginTop: '15px' }}>
                                   <div>
                                     <select
                                       value={this.state.selectedProgram}
                                       onChange={(e) => this.setState({ selectedProgram: e.target.value, selectedEligibilityCode: '' })}
                                     >
                                       <option value="">Select Program</option>
                                       <option value="Free">Free</option>
                                       <option value="Reduced">Reduced</option>
                                       <option value="Regular">Paid/Regular</option>
                                     </select>
                   
                                   </div>
                                   {this.state.selectedProgram === 'Free' || this.state.selectedProgram === 'Reduced' ? (
                                      <div style={{ marginTop: '10px' }}>
                                           <div className="form-group">
                                               <label htmlFor="editEligibilityCodes">
                                                   Eligibility Codes:
                                               </label>
                   
                                               <select
                                                   className="form-control"
                                                   id="editEligibilityCodes"
                                                   value={this.state.selectedEligibilityCode}
                                                   onChange={(e) => this.setState({ selectedEligibilityCode: e.target.value })}
                                                   style={{ width: '80%' }}
                                                   required
                                               >
                                               <option value=""></option>
                   
                                               {
                                                   (this.state.eligibilityCodes || [])
                                                       .filter(code => {
                                                           if (this.state.selectedProgram === 'Reduced') {
                                                               return code.redElig === true;
                   
                                                           } else if (this.state.selectedProgram === 'Free') {
                                                               return code.freeElig === true;
                                                           } else {
                                                               return false;
                                                           }
                                                       })
                                                       .map((code, i) => (
                                                           <option key={i} value={code.codeDesc}>
                                                               {code.codeDesc}
                                                           </option>
                                                       ))
                                               }
                                               </select>
                                           </div>
                                       </div>
                                      ) : null}
                                   </div>               
                                 )}             
                                 {this.state.decisionType === 'NO' && (
                                   <button type="button" className="btn btn-success btn-sm" onClick={() => this.updateFinalDecision(this.state.selectedRow, false)} >Confirm With Existing Status</button> 
                                 )}
                                   <button type="button" className="btn btn-primary btn-sm" onClick={this.closeFinalDecisionModal}>Cancel</button>
                                 {this.state.decisionType === 'YES' && (
                                   <button type="button" className="btn btn-success btn-sm"  onClick={() => this.updateFinalDecision(this.state.selectedRow, true)}>Record Final Decision</button>
                                  )}
                        </Modal.Body>
                    </Modal>
            <Modal 
                show={this.state.showApplicationModal}
                onHide={this.closeApplicationModal}
                bsSize="lg"
                dialogClassName="application-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Household Application {this.state.selectedApplicationData ? this.state.selectedApplicationData.applicationId : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    {this.state.isLoadingApplication ? (
                        <div className="text-center" style={{ padding: '20px' }}>
                            <i className="fa fa-spinner fa-spin"></i> Loading application details...
                        </div>
                    ) : this.state.selectedApplicationData ? (
                        <SchoolMealProgramView
                            id={this.state.selectedApplicationData.applicationId}
                            appData={this.state.selectedApplicationData}
                            confirmingOfficialUserIds={[]}
                            enableConfirmingOfficial={false}
                            autoDecisionEligibility={false}
                            loggedUser={JSON.parse(sessionStorage.getItem('loggedInUserDetails') || '{}')}
                            refNotify={this}
                            onSubmitChanges={this.handleVerificationIncomeSave}
                            enableVerificationSave={true}
                            isVerificationFlow={true}
                            verificationMode={this.state.verificationMode}
                            onVerificationSave={this.saveVerificationIncome}
                            onClose={this.closeApplicationModal}
                            isAdmin={true}
                            eligibilityDeterminedByProgram={this.state.selectedApplicationData.eligibilityDeterminedByProgram}
                        />
                    ) : null}
                </Modal.Body>
            </Modal>

        <Modal
            show={this.state.showUnmarkModal}
            onHide={this.closeUnmarkModal}
            backdrop="static"
        >
           <Modal.Header closeButton>
            <Modal.Title className= 'text-danger'>
                <i
                    className="fa fa-exclamation-triangle text-danger"
                    style={{ marginRight: 8,  }}
                />
                Confirm Un Mark Responded
            </Modal.Title>
           </Modal.Header>
           <Modal.Body> 
             <div
                className="alert alert-warning"
                style={{ marginBottom: 20 }}
            >
            <strong>Warning:</strong>
              Are you sure you want to remove the <strong>"Responded"</strong> status for this application?
            This application will return to <strong>Awaiting Response.</strong>
            <br />
             No income has been recorded for this application.
           </div>
           </Modal.Body>
           <Modal.Footer>
                <button
                    className="btn btn-danger"
                    onClick={this.closeUnmarkModal}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-success"
                    style={{ marginBottom: '17px' }}
                    onClick={this.confirmUnmark}
                >
                    Yes, Un-mark Response
                </button>
            </Modal.Footer>
        </Modal>
         <Modal
                show={this.state.showFinalizeModal}
                onHide={this.closeFinalizeModal}
                backdrop="static"  >
                <Modal.Header closeButton>
                    <Modal.Title>
                       <h4 className='modal-title modal-title-color'>Finalize Verification</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="alert alert-warning">
                            <strong>
                               {this.state.finalizeData.confirmationSummary}
                            </strong>   
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td><strong>Application</strong></td>
                                    <td>{this.state.finalizeData ? this.state.finalizeData.applicationId : ''}</td>
                                </tr>
                                <tr>
                                    <td><strong>Outcome</strong></td>
                                    <td>
                                        <span className="label label-default"
                                            style={{
                                                borderRadius: '999px',
                                                fontSize: '14px',
                                                padding: '6px 10px',
                                                display: 'inline-block',
                                                marginRight: '8px'
                                            }}
                                        >
                                            {this.state.finalizeData ? this.state.finalizeData.currentEligibility : ''}
                                        </span>
                                        <span style={{ margin: '0 8px', color: '#999', fontWeight: 'bold' }}>
                                            →
                                        </span>
                                        <span className="label label-primary"
                                            style={{
                                                borderRadius: '999px',
                                                fontSize: '14px',
                                                padding: '6px 10px',
                                                display: 'inline-block',
                                                marginLeft: '8px'
                                            }}
                                        >
                                            {this.state.finalizeData ? this.state.finalizeData.finalEligibility : ''}
                                        </span>
                                    </td>
                                </tr>
                              {this.state.finalizeData.downgrade ? (
                                <Fragment>
                                <tr>
                                    <td><strong>Reason On Letter</strong></td>
                                    <td>{this.state.finalizeData.reason}</td>
                                </tr>
                                <tr>
                                    <td><strong>Downgrade Effective</strong></td>
                                    <td>{this.state.finalizeData.downgradeEffectiveDate}{'(10-day buffer)'}</td>
                                </tr>
                                </Fragment>
                                ) : null}
                            </tbody>
                        </table>
                        {this.state.finalizeData.downgrade ? (
                        <div className="alert alert-info">
                           <i className="fa fa-envelope-o" style={{ marginRight: '8px', fontSize: '16px' }} ></i>An adverse-action Results letter emails to the parent to confirm.
                        </div>
                        ) :
                        (<div className="alert alert-info">
                           <i className="fa fa-envelope-o" style={{ marginRight: '8px', fontSize: '16px' }} ></i>The household is notified of the result by email/SMS. No formal letter is sent.
                         </div>) }
                    </div>
                </Modal.Body>
            <Modal.Footer>
            <div>
                <button
                    className="btn btn-danger btn-sm"
                    onClick={this.closeFinalizeModal}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-success btn-sm"
                    style={{ marginBottom: '17px' }}
                    onClick={() =>
                        this.confirmCompleteVerification(this.state.finalizeData)
                    }
                >
                    {this.state.finalizeData &&
                    this.state.finalizeData.downgrade
                        ? "Confirm & Send Letter"
                        : 
                        "Confirm"  
                    }            
                </button>
            </div>
            </Modal.Footer>
        </Modal>
        <Modal
            show={this.state.showLetterLogModal}
            onHide={this.closeLetterLogModal}
            bsSize="lg"
            backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                <h4 className='modal-title modal-title-color'><i className="fa fa-envelope-open-o" /> View Letter Log</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <div className="col-md-12">
                        <strong>Communication Log</strong>
                    </div>
                    <br />
                    <div className="col-md-12">
                    <p>Every letter and notice sent for this household. Download opens the exact PDF stored at send time.</p>
                    </div>
                <ReactTable
                    data={this.state.viewLetter}
                    columns={this.getLetterLogColumns()}
                    defaultPageSize={5}
                    minRows={0}
                    className="-striped -highlight"
                />
           </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-danger btn-sm"
                    onClick={this.closeLetterLogModal}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>
      </Fragment>
     );
  }
}
export default ApplicationVerificationUpdate;


// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/applicationVerificationUpdate.js